$(document).ready(function() {
  $('.js-cybermonday__container__upsell__skip').click(function(event){
    event.preventDefault();
    window.parent.postMessage('closeDialog', '*');
  });
});
